import React, {lazy, Suspense} from 'react';
import {Redirect} from "react-router-dom";
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import {withTranslation} from 'react-i18next';
import Skeleton from '@material-ui/lab/Skeleton';
import ls from 'local-storage';
import DashboardFrame from '../components/DashboardFrame';
import {updateUser, getPromises, removePromise, updatePromise} from '../redux/auth/actions';
import {handleError} from '../redux/common/actions';
import ChannelService from "../lib/ChannelService";

const Section1 = lazy(() => import('../components/Homepage/Section1'));
const Section2 = lazy(() => import('../components/Homepage/Section2'));
const AppBar = lazy(() => import('../components/AppBar'));
const AppFooter = lazy(() => import('../components/AppFooter'));

const useStyles = theme => ({
    root: {
        overflowX: 'hidden'
    },
});


class Home extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

        ChannelService.boot({
            "pluginKey": process.env.REACT_APP_PLUGIN_KEY,
            "language": "ko",
        });

        if ((typeof this.props.match.params.locale !== 'undefined') && ((this.props.match.params.locale === 'en') || (this.props.match.params.locale === 'ko'))) {
            this.props.i18n.language = this.props.match.params.locale.toString();
        } else {
            this.props.i18n.language = 'ko';
        }
    }

    componentWillUnmount() {
        ChannelService.shutdown();
    }

    render() {

        const { classes } = this.props;
        const isLoggedIn = ls.get('isLoggedIn');

        if (!this.props.user) {
            return (
                <DashboardFrame>
                </DashboardFrame>
            )
        }

        return (
            (!isLoggedIn ?
                    <Suspense fallback={
                        <React.Fragment>
                            <Skeleton/>
                        </React.Fragment>
                    }>
                        <React.Fragment>
                            <Suspense fallback={
                                <React.Fragment>
                                    <Skeleton variant={'rect'} width={'100%'} style={{ marginTop: '0px' }}>
                                        <div style={{ minHeight: '9vh' }}/>
                                    </Skeleton>
                                    <Skeleton variant={'rect'} width={'100%'} style={{ marginTop: '10px' }}>
                                        <div style={{ minHeight: '80vh' }}/>
                                    </Skeleton>
                                </React.Fragment>
                            }>
                                <div className={classes.root}>
                                    <AppBar/>
                                    <Section1/>
                                    {/* <Section2/> */}
                                    <AppFooter/>
                                </div>
                            </Suspense>
                        </React.Fragment>
                    </Suspense> : <Redirect to={'/my-promise'}/>
            )
        );
    }
}

Home.defaultProps = {
    promises: []
};

const mapStateToProps = state => ({
    user: state.auth.user,
    promises: state.auth.promises
});

const mapDispatchToProps = dispatch => ({
    updateUser: (user) => dispatch(updateUser(user)),
    getPromises: (promises) => dispatch(getPromises(promises)),
    removePromise: (promise) => dispatch(removePromise(promise)),
    updatePromise: (promise) => dispatch(updatePromise(promise)),
    handleError: (showError, message) => dispatch(handleError(showError, message))
});

export default withStyles(useStyles)(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Home)));
